__turbopack_context__.v({
  "item": "WalletPaymentMethodSelector-module__5Sq_0q__item",
  "itemFullWidth": "WalletPaymentMethodSelector-module__5Sq_0q__itemFullWidth",
  "radioGroup": "WalletPaymentMethodSelector-module__5Sq_0q__radioGroup",
});
